import { render } from "./TacticContextStylesItems.vue?vue&type=template&id=02a2375e&scoped=true"
import script from "./TacticContextStylesItems.vue?vue&type=script&lang=js"
export * from "./TacticContextStylesItems.vue?vue&type=script&lang=js"

import "./TacticContextStylesItems.vue?vue&type=style&index=0&id=02a2375e&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02a2375e"]])

export default __exports__